import { UiNode, UiNodeInputAttributes } from '@ory/client';
import { Alert, Stack, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { Button } from 'src/components';
import { OidcFormButton } from 'src/components/convenience/auth/OidcFormButton';
import { AuthFeedback } from 'src/auth/components/AuthFeedback';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { AuthMethod } from 'src/auth/settings/types';
import { isSsoOnly } from 'src/auth/utils/ory-helpers';

interface WelcomeSectionProps {
  firstName: string;
  inviterName: string;
  userEmail: string;
  error: string | null;
  onAcceptInvite: () => void;
  variant: AuthMethod;
  oidcNodes: UiNode[];
  formAction: string;
  csrfToken: string;
}

export const WelcomeSection = ({
  firstName,
  inviterName,
  userEmail,
  error,
  onAcceptInvite,
  variant,
  oidcNodes,
  formAction,
  csrfToken,
}: WelcomeSectionProps) => (
  <Stack align="center" gap="md">
    <Text c="gray.0" fz={36} fw={FONT_WEIGHTS.bold}>
      {firstName ? `Hi, ${firstName}!` : 'Welcome!'}
    </Text>
    <Text c="gray.0" ta="center" fz={24} fw={FONT_WEIGHTS.medium}>
      {inviterName
        ? `You have been invited by ${inviterName} to join Afternoon.`
        : 'You have been invited to join Afternoon.'}
      <br />
      {isSsoOnly(variant)
        ? 'Please sign in with your organization account to continue'
        : 'Please create your profile to continue'}
    </Text>
    {userEmail && (
      <Text c="gray.5" size="sm">
        {userEmail}
      </Text>
    )}

    <AuthFeedback error={error} />

    {!isSsoOnly(variant) ? (
      <Button onClick={onAcceptInvite} disabled={!!error} size="lg">
        Accept invite & create profile
      </Button>
    ) : oidcNodes.length > 0 ? (
      <Stack gap="sm" w={300}>
        {oidcNodes.map(node => (
          <OidcFormButton
            key={(node.attributes as UiNodeInputAttributes).value as string}
            node={node}
            formAction={formAction}
            csrfToken={csrfToken}
            action="link"
          />
        ))}
      </Stack>
    ) : (
      <Alert icon={<IconAlertCircle size={16} />} color="yellow" variant="light" maw={450} w="100%">
        No SSO providers configured. Please contact your administrator.
      </Alert>
    )}
  </Stack>
);
